import React, { useState } from "react";
import { useIrAPadre } from "@/components/BotonVolver";
import { useParams } from "react-router-dom";
import * as Icons from "lucide-react";
import { useData } from "@/context/DataContext";
import { MatterGroups } from "@/components/MatterGroups";
import { abrirVisor } from "@/lib/visor";
import { agendaPersona, useGestiones } from "@/lib/personaAgenda";
import { useOcurrencias } from "@/components/gestiones/Ocurrencias";
import { Avatar } from "@/components/personas/Avatar";
import { AgendaPersona, AnterioresPersona } from "@/components/personas/AgendaPersona";
import { Contadores, PersonaSheet, relacionTxt } from "@/pages/Familia";

const Seccion = ({ titulo, icon: I, children, testid }) => (
  <section className="space-y-3" data-testid={testid}>
    <h2 className="font-heading text-xl font-bold text-[#1C2421] flex items-center gap-2"><I size={22} className="text-[#3A6B56]" /> {titulo}</h2>
    {children}
  </section>
);
const fila = "w-full text-left bg-white border border-[#E5DFD5] rounded-2xl px-4 py-3 flex items-center gap-3 hover:border-[#3A6B56]";

export default function PersonaDetalle() {
  const { id } = useParams();
  const irA = useIrAPadre();
  const { familyMembers, matters, documents, reminders = [] } = useData();
  const [modal, setModal] = useState(null);
  const gestiones = useGestiones();
  const [ocs] = useOcurrencias();
  const p = familyMembers.find((f) => f.id === id);
  if (!p) return <p className="text-lg text-[#6E7A74]" data-testid="persona-no-encontrada">Esta persona no existe.</p>;
  const docs = documents.filter((d) => d.family_member_id === p.id);
  const ag = agendaPersona({ p, matters, reminders, gestiones, ocs, familyMembers });
  const asuntos = ag.asuntos;
  const vacia = !asuntos.length && !docs.length && !ag.total && !ag.anteriores.length;
  const anadir = () => window.dispatchEvent(new CustomEvent("aldia-add", { detail: { persona: p.id } }));
  return (
    <div className="space-y-6" data-testid="persona-detalle">
      <button data-testid="persona-volver" onClick={() => irA("/personas")} className="min-h-[48px] inline-flex items-center gap-1 text-base font-semibold text-[#3A6B56]"><Icons.ChevronLeft size={20} /> Volver a Familia</button>
      <header className="flex items-center gap-4">
        <Avatar persona={p} size="lg" testid="persona-avatar" />
        <div><h1 className="font-heading text-3xl font-bold text-[#1C2421]" data-testid="persona-nombre">Información de {p.name}</h1><p className="text-lg text-[#4A5550]">{relacionTxt(p)}</p></div>
      </header>
      <div className="bg-white border border-[#E5DFD5] rounded-2xl p-4" data-testid="persona-resumen"><Contadores s={ag.contadores} id={p.id} /></div>
      <div className="flex flex-col gap-3">
        <button data-testid="persona-anadir" onClick={anadir} className="w-full min-h-[60px] rounded-2xl bg-[#3A6B56] text-white font-bold text-lg inline-flex items-center justify-center gap-2 shadow-md hover:bg-[#2E5645]"><Icons.PlusCircle size={22} /> Añadir información para {p.name}</button>
        <button data-testid="persona-editar" onClick={() => setModal({ mode: "edit", ...p })} className="w-full min-h-[52px] rounded-2xl bg-white border border-[#D6CFC2] text-[#1C2421] font-semibold text-lg inline-flex items-center justify-center gap-2"><Icons.Pencil size={18} /> Editar datos</button>
      </div>
      {(p.telefono || p.email || p.direccion) && (
        <div className="bg-white border border-[#E5DFD5] rounded-2xl p-4 space-y-2 text-base text-[#1C2421]" data-testid="persona-datos">
          {p.telefono && <a href={`tel:${p.telefono.replace(/[^\d+]/g, "")}`} className="flex items-center gap-2" data-testid="persona-telefono"><Icons.Phone size={18} className="text-[#3A6B56]" /> {p.telefono}</a>}
          {p.email && <a href={`mailto:${p.email}`} className="flex items-center gap-2 break-all" data-testid="persona-email"><Icons.Mail size={18} className="text-[#3A6B56] shrink-0" /> {p.email}</a>}
          {p.direccion && <p className="flex items-start gap-2" data-testid="persona-direccion"><Icons.MapPin size={18} className="text-[#3A6B56] shrink-0 mt-0.5" /> {p.direccion}</p>}
        </div>
      )}
      {vacia ? (
        <div data-testid="persona-vacia" className="bg-white border border-dashed border-[#C9D8CF] rounded-3xl p-6 text-center space-y-3">
          <p className="text-xl font-semibold text-[#1C2421]">Todavía no has guardado información de {p.name}.</p>
          <p className="text-lg text-[#4A5550]">Puedes añadir documentos, citas, recordatorios u otros asuntos relacionados con esta persona.</p>
          <button data-testid="persona-vacia-anadir" onClick={anadir} className="w-full min-h-[56px] rounded-2xl bg-[#3A6B56] text-white font-bold text-lg">Añadir información para {p.name}</button>
        </div>
      ) : (<>
        {ag.total > 0 && <Seccion titulo="Sus citas y recordatorios" icon={Icons.CalendarDays} testid="persona-citas"><AgendaPersona grupos={ag.grupos} /></Seccion>}
        {asuntos.length > 0 && <Seccion titulo="Sus asuntos" icon={Icons.FolderOpen} testid="persona-asuntos"><MatterGroups matters={asuntos} historico emptyText="" /></Seccion>}
        {docs.length > 0 && (
          <Seccion titulo="Sus documentos" icon={Icons.FileText} testid="persona-documentos">
            {docs.map((d) => (
              <button key={d.id} data-testid={`persona-doc-${d.id}`} onClick={() => abrirVisor(d)} className={fila}>
                <Icons.FileText size={20} className="text-[#3A6B56] shrink-0" />
                <span className="flex-1 min-w-0"><span className="block text-base font-semibold text-[#1C2421] truncate">{d.title || d.original_filename}</span><span className="block text-sm text-[#6E7A74]">{d.category}</span></span>
                <Icons.Eye size={18} className="text-[#6E7A74]" />
              </button>
            ))}
          </Seccion>
        )}
        <AnterioresPersona gestiones={ag.anteriores} />
      </>)}
      {modal && <PersonaSheet modal={modal} setModal={setModal} />}
    </div>
  );
}
